module.exports = __webpack_public_path__ + "static/img/skill-teamfight.384bd615.png";